import styled from 'styled-components';
import Card from '@components/common/Card';

export const Wrapper = styled.div`
  padding: 0 7rem;
  @media (max-width: ${({ theme }) => theme.breakPoints.lg}) {
    padding: 0;
  }
`;

export const StyledCard = styled(Card)`
  width: 67%;
  align-items: center;
  justify-content: center;
  text-align: center;
  padding: 5rem 0 4rem;
  margin: 8rem auto 6rem;
  color: ${({ theme }) => theme.colors.primary.main};
  h3 {
    margin-bottom: 2rem;
  }
  h4 {
    font-weight: 400;
  }
  p {
    margin-bottom: 0;
  }
  @media (max-width: ${({ theme }) => theme.breakPoints.lg}) {
    width: 100%;
  }
`;
